/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_UnderstandingInputs */

const en_onboarding_understanding = /** @type {(inputs: Onboarding_UnderstandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understanding responses`)
};

const es_onboarding_understanding = /** @type {(inputs: Onboarding_UnderstandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizando respuestas`)
};

/**
* | output |
* | --- |
* | "Understanding responses" |
*
* @param {Onboarding_UnderstandingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_understanding = /** @type {((inputs?: Onboarding_UnderstandingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_UnderstandingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_understanding(inputs)
	return en_onboarding_understanding(inputs)
});